<script>

  import { createEventDispatcher,onDestroy,onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { language } from './js/AppState';
  import SGMSApi from './js/SGMSApi';


  const dispatch = createEventDispatcher();

  let video_element;
  let currenttime
  let showPlayBtn = true
  let videofile = "video/intro_"
  videofile += $language === "fr" ? "fr" : "en"
  videofile += ".mp4"

  function skipVideo(e) {
    video_element.currentTime = video_element.duration
    SGMSApi.sendActionEvent(e, "SkipVideoBtn")
    SGMSApi.sendContentEvent(videofile, "INTERRUPTED")
  }

  function openFullscreen() {
    if (document.body.requestFullscreen) {
      document.body.requestFullscreen();
    } else if (document.body.mozRequestFullScreen) { /* Firefox */
      document.body.mozRequestFullScreen();
    } else if (document.body.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      document.body.webkitRequestFullscreen();
    } else if (document.body.msRequestFullscreen) { /* IE/Edge */
      document.body.msRequestFullscreen();
    }
  }

  onMount(() => {
    video_element.addEventListener('ended', onVideoEnd)
  })
  onDestroy(() => {
    video_element.removeEventListener('ended', onVideoEnd)
  })

  function onVideoEnd() {
    SGMSApi.sendContentEvent(videofile, "HIDE")
    dispatch("videoend")
  }

  function playVideo(e) {
    SGMSApi.sendActionEvent(e, "PlayVideoBtn")
    SGMSApi.sendContentEvent(videofile, "SHOW")
    showPlayBtn = false
    video_element.play()
    openFullscreen()
  }


</script>

<div class="video-screen" in:fade>
  <video controls={false} bind:this={video_element}>
    <source src={videofile} type="video/mp4">
    <track kind="captions" src={ `${window.CONFIG.assets_root}video_subtitles_${$language}.vtt`} default>
  </video>

  {#if showPlayBtn}
    <button class="play" on:click={playVideo}></button>
  {:else}
    <button class="skip-btn" on:click={skipVideo}></button>
  {/if}

</div>

<style>

.video-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: #fff;
  z-index: 3;
}

::cue {
  background: rgba(0, 0, 0, 0.411);
  line-height: 1.2em;
  font-size: 0.9em;
  text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.822);

}
video {
  width: 100%;
  height: 100%;
}

button {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  border: none;
  outline: none;
  cursor: pointer;
}
button:active{
  background-color: transparent;
}

.play {
  top: 50%;
  left: 50%;
  transform: translateX(-50%)  translateY(-50%);

  width: 114px;
  height: 130px;
  background: url('../images/playBtn.png') center center no-repeat;
}
.skip-btn {
  width: 60px;
  height: 60px;

  top: 40px;
  left: 40px;

  background: url('../images/skipBtn.png') center center no-repeat;
  background-size: contain;
  opacity: 1;
}
</style>
